var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remove-account"},[_c('modal-remove-account',{directives:[{name:"show",rawName:"v-show",value:(_vm.profile),expression:"profile"}],ref:"modalResetRef",attrs:{"lineId":_vm.profile.userId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }